"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFloatMenuBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var common_constants_2 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var bc_float_menu_constants_1 = require("./bc-float-menu-constants");
var bc_checkbox_constants_1 = require("../../atoms/bc-checkbox/bc-checkbox-constants");
var BcFloatMenuBehavior = (function (_super) {
    __extends(BcFloatMenuBehavior, _super);
    function BcFloatMenuBehavior() {
        var _this = _super.call(this) || this;
        _this.floatMenuContent = null;
        _this.toggleButton = null;
        _this.aElement = null;
        _this.liElement = null;
        _this.liElements = null;
        _this.inputSelectElement = null;
        _this.checkIfPositionLeft = null;
        _this.checkIfPositionRight = null;
        _this.arrowElement = null;
        return _this;
    }
    BcFloatMenuBehavior.setUpAll = function () {
        var floatMenuElements = Array.from(document.querySelectorAll("[class~='".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CLASS, "']:not([configured])")));
        return floatMenuElements.map(function (element) {
            var bcFloatMenuBehavior = new BcFloatMenuBehavior();
            bcFloatMenuBehavior.setElement(element);
            bcFloatMenuBehavior.setUp();
            return bcFloatMenuBehavior;
        });
    };
    BcFloatMenuBehavior.prototype._setUp = function () {
        this._setState();
        this._setAccesibility();
        this._setHandlers();
    };
    BcFloatMenuBehavior.prototype._setState = function () {
        this._setElements(this.mySelf);
        this._setFloatWidth(this.mySelf);
        this._validateIfCheckboxOrRadioButtons();
        this._itemsArrow();
    };
    BcFloatMenuBehavior.prototype._setHandlers = function () {
        this._eventListenerWindowCloseFloatMenu();
        this._eventListenerSelectedLiElementes();
        this._setListenerArrowKeysLiElements();
        this._addKeyboardEventsHandler();
        this._eventListenerToggleButtonCloseOrOpenFloatMenu();
    };
    BcFloatMenuBehavior.prototype._setElements = function (mySelf) {
        this.toggleButton = mySelf.previousElementSibling;
        this.inputSelectElement = this.toggleButton;
        this.floatMenuContent = mySelf.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS));
        this.liElement = this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.LI_TAG);
        this.checkIfPositionLeft = mySelf.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_LEFT));
        this.checkIfPositionRight = mySelf.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_RIGHT));
        this.liElements = Array.from(this.floatMenuContent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
        this.arrowElement = mySelf.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW));
        this.mySelf.toggleAttribute('configured', true);
    };
    BcFloatMenuBehavior.prototype._setFloatWidth = function (mySelf) {
        var _a, _b, _c;
        if (!((_a = this.inputSelectElement.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_INPUT_SELECT_CLASS))) {
            var al = this.toggleButton.getBoundingClientRect();
            mySelf.style.width = "".concat(al.width, "px");
            if (((_b = this.mySelf.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_LEFT)) ||
                ((_c = this.mySelf.classList) === null || _c === void 0 ? void 0 : _c.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_RIGHT)) ||
                this.arrowElement !== null) {
                mySelf.style.height = "".concat(al.height, "px");
            }
        }
        else {
            var parentWidth = this.inputSelectElement.clientWidth;
            var width = this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
            this.floatMenuContent.style.width = "".concat(parentWidth, "px");
            this.floatMenuContent.style.overflowX = common_constants_1.BcCommonConstants.HIDDEN;
            width.style.maxWidth = common_constants_1.BcCommonConstants.NONE;
        }
    };
    BcFloatMenuBehavior.prototype._eventListenerToggleButtonCloseOrOpenFloatMenu = function () {
        var _this = this;
        this.toggleButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            var isEnterOrSpace = event['code'] === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event['code'] === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER;
            if (isEnterOrSpace && !_this.floatMenuActive) {
                _this.openDropdown(true);
            }
            else if (isEnterOrSpace && _this.floatMenuActive) {
                _this.closeDropdown();
            }
        });
        this.toggleButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEDOWN, function () {
            _this.toggleDropdown();
        });
    };
    BcFloatMenuBehavior.prototype._listenerIsToggleElement = function (element) {
        var _a;
        var dot = '.';
        var hasClosestFunction = typeof element.closest === 'function';
        return ((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_TOGGLE_CLASS)) || hasClosestFunction
            ? element.closest(dot + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_TOGGLE_CLASS) !== null
            : false;
    };
    BcFloatMenuBehavior.prototype._listenerIsNotCheckboxAndRadio = function (element) {
        var _a, _b, _c;
        var dot = '.';
        var hasClosestFunction = typeof element.closest === 'function';
        var checkbox = ((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS)) || hasClosestFunction
            ? element.closest(dot + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS) !== null
            : false;
        var radio = ((_b = element.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_GROUP_CLASS)) ||
            ((_c = element.classList) === null || _c === void 0 ? void 0 : _c.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_LABEL)) ||
            hasClosestFunction
            ? element.closest(dot + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_GROUP_CLASS) !== null
            : false;
        return !checkbox && !radio;
    };
    BcFloatMenuBehavior.prototype._eventListenerWindowCloseFloatMenu = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var _a;
            var element = event.target;
            var isToggleElement = _this._listenerIsToggleElement(element);
            var isMainElement = (_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OPTION_CLASS);
            var isNotCheckboxAndRadio = _this._listenerIsNotCheckboxAndRadio(element);
            var isNotToggleAndMain = !isToggleElement && !isMainElement;
            if (_this.floatMenuActive && isNotToggleAndMain && isNotCheckboxAndRadio) {
                _this.toggleDropdown(true);
            }
        });
    };
    BcFloatMenuBehavior.prototype._deleteSelectedItem = function (item) {
        var _a, _b, _c;
        var aSelected = item.querySelector(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_A_TAG_ELEMENT);
        if (((_b = (_a = aSelected.nextElementSibling) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.innerHTML) === bc_float_menu_constants_1.BcFloatMenuConstansts.TEXT_OK) {
            aSelected.nextElementSibling.nextElementSibling.remove();
        }
        else if (((_c = aSelected.nextElementSibling) === null || _c === void 0 ? void 0 : _c.innerHTML) === bc_float_menu_constants_1.BcFloatMenuConstansts.TEXT_OK) {
            aSelected.nextElementSibling.remove();
        }
        if (this._checkSiblingElementEM(aSelected)) {
            aSelected.nextElementSibling.classList.remove(common_constants_1.BcCommonConstants.INVISIBLE_CLASS);
        }
    };
    BcFloatMenuBehavior.prototype._checkIfSelectedItems = function (ilElements) {
        var _a, _b, _c;
        for (var _i = 0, ilElements_1 = ilElements; _i < ilElements_1.length; _i++) {
            var item = ilElements_1[_i];
            var isIt = item;
            if ((this._isCheckboxElement(item) &&
                !((_a = isIt.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS))) ||
                (!this._isCheckboxElement(item) &&
                    ((_b = isIt.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS)))) {
                isIt.classList.remove(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
                isIt.removeAttribute(common_constants_1.BcCommonConstants.ARIA_PRESSED);
                if ((_c = this.floatMenuContent.classList) === null || _c === void 0 ? void 0 : _c.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ICON_CLASS)) {
                    this._deleteSelectedItem(isIt);
                }
            }
        }
    };
    BcFloatMenuBehavior.prototype._selectedBehavior = function (event) {
        if (!this._isDisabledElement(event)) {
            var floatMenuContentCurrent = this._validateIfCheckboxOrRadioButtons()
                ? event.parentElement.parentElement.parentElement.parentElement
                : event.parentNode;
            var ilElements = Array.from(floatMenuContentCurrent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
            if (this._deleteSelectedCheckbox(event)) {
                this._checkIfSelectedItems(ilElements);
                return;
            }
            this._checkIfSelectedItems(ilElements);
            this._putSelected(event);
            if (!this._isCheckboxElement(event) && !this._isRadiobuttonElement(event)) {
                this.toggleButton.focus();
                this.toggleDropdown(true);
            }
        }
    };
    BcFloatMenuBehavior.prototype._deleteSelectedCheckbox = function (event) {
        var _a, _b;
        if (this._isCheckboxElement(event)) {
            if ((_a = event.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_checkbox_constants_1.CHECKBOX_CLASS)) {
                event = event.parentElement.parentElement;
            }
            if (((_b = event.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS)) === true) {
                var checkboxElement = event.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
                checkboxElement.checked = false;
                checkboxElement.removeAttribute('checked');
                event.classList.remove(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
                return true;
            }
        }
        return false;
    };
    BcFloatMenuBehavior.prototype._isCheckboxElement = function (elem) {
        var _a;
        var hasCheckboxAttr = elem.getAttribute('type') === bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_TAG;
        var hasCheckboxClass = elem.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS)) !== null;
        var containsCheckboxClass = ((_a = elem.classList) === null || _a === void 0 ? void 0 : _a.contains("".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS))) === true;
        return hasCheckboxAttr || containsCheckboxClass || hasCheckboxClass;
    };
    BcFloatMenuBehavior.prototype._isRadiobuttonElement = function (elem) {
        var _a;
        var hasRadioGroupClass = elem.querySelector(".".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_GROUP_CLASS)) !== null;
        var hasRadioLabel = ((_a = elem.classList) === null || _a === void 0 ? void 0 : _a.contains("".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_LABEL))) === true;
        return hasRadioGroupClass || hasRadioLabel;
    };
    BcFloatMenuBehavior.prototype._putSelected = function (event) {
        var _a, _b;
        var selected = event;
        if (this._validateIfCheckboxOrRadioButtons()) {
            selected = this._putValueToCheckbox(selected);
        }
        selected.setAttribute(common_constants_1.BcCommonConstants.ARIA_PRESSED, common_constants_1.BcCommonConstants.TRUE.toString());
        selected.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ITEM_CLASS);
        this.aElement = selected.querySelector(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_A_TAG_ELEMENT);
        if (!((_a = this.floatMenuContent.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_SELECTED_ICON_CLASS))) {
            return;
        }
        if (this._checkSiblingElementEM(this.aElement)) {
            (_b = this.aElement.nextElementSibling) === null || _b === void 0 ? void 0 : _b.classList.add(common_constants_1.BcCommonConstants.INVISIBLE_CLASS);
        }
        var em = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        em.textContent = bc_float_menu_constants_1.BcFloatMenuConstansts.TEXT_OK;
        em.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        em.classList.add(common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        selected.appendChild(em);
    };
    BcFloatMenuBehavior.prototype._putValueToCheckbox = function (selected) {
        var _a, _b;
        var a = selected.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG) === null
            ? selected
            : selected.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
        a.checked = true;
        a.setAttribute('checked', 'checked');
        if ((_a = selected.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS)) {
            return selected.parentElement.parentElement;
        }
        if ((_b = selected.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_LABEL)) {
            return selected.parentElement.parentElement.parentElement;
        }
        return selected;
    };
    BcFloatMenuBehavior.prototype._checkSiblingElementEM = function (selected) {
        if (selected.nextElementSibling !== null) {
            return (selected.nextElementSibling.nodeName.toLowerCase() === common_constants_1.BcCommonConstants.EM_TAG ||
                selected.nextElementSibling.nodeName.toLowerCase() === common_constants_1.BcCommonConstants.IMG_TAG);
        }
        else {
            return false;
        }
    };
    BcFloatMenuBehavior.prototype._safariInputListeners = function (elementLi) {
        var _this = this;
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var isCheckboxOrRadio = this._isCheckboxElement(elementLi) || this._isRadiobuttonElement(elementLi);
        if (isSafari && isCheckboxOrRadio) {
            elementLi.querySelector('input').addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var clickElement = event.target;
                event.stopPropagation();
                if (clickElement.getAttribute('type') == bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_TAG) {
                    var parentElement = clickElement.parentElement.parentElement.parentElement;
                    _this._selectedBehavior(parentElement);
                }
                if (clickElement.getAttribute('type') == bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_TAG) {
                    var parentElement = clickElement.parentElement.parentElement.parentElement.parentElement;
                    _this._selectedBehavior(parentElement);
                }
            });
        }
    };
    BcFloatMenuBehavior.prototype._eventListenerSelectedLiElementes = function () {
        var _this = this;
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var elementLi = _a[_i];
            this._safariInputListeners(elementLi);
            elementLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                event.preventDefault();
                var clickElement = event.target;
                _this._selectedBehavior(clickElement);
            });
        }
    };
    BcFloatMenuBehavior.prototype._positionOfEnabledLi = function () {
        var pos = 0;
        var arrPos = [];
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var _1 = _a[_i];
            arrPos.push(pos);
            pos++;
        }
        return arrPos;
    };
    BcFloatMenuBehavior.prototype._setListenerArrowKeysLiElements = function () {
        var _this = this;
        var _loop_1 = function (elementLi) {
            elementLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN ||
                    event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    event.preventDefault();
                    var target = elementLi;
                    var li = target.closest(common_constants_1.BcCommonConstants.LI_TAG);
                    var nodes = Array.from(li.closest(common_constants_1.BcCommonConstants.UL_TAG).children);
                    var index = nodes.indexOf(li);
                    var arrPos = _this._positionOfEnabledLi();
                    var itemPos = arrPos.indexOf(index);
                    var newIndex = event['key'] === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN ? itemPos + 1 : itemPos - 1;
                    if (newIndex == arrPos.length) {
                        newIndex = 0;
                    }
                    else if (newIndex == -1) {
                        newIndex = arrPos.length - 1;
                    }
                    var newPos = arrPos[newIndex];
                    _this.liElements[newPos].focus();
                }
            });
        };
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var elementLi = _a[_i];
            _loop_1(elementLi);
        }
    };
    BcFloatMenuBehavior.prototype._validateIfCheckboxOrRadioButtons = function () {
        return (this.liElement.innerHTML.includes(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_RADIO_GROUP_CLASS) ||
            this.liElement.innerHTML.includes(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS));
    };
    BcFloatMenuBehavior.prototype.openDropdown = function (keyboardEvent) {
        if (keyboardEvent === void 0) { keyboardEvent = false; }
        this._closeAll();
        (0, helpers_1.replaceClass)(this.floatMenuContent, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS);
        (0, helpers_1.replaceClass)(this.arrowElement, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE);
        this.setDropdownContentPosition();
        this.floatMenuActive = true;
        if (keyboardEvent) {
            var arrPos = this._positionOfEnabledLi();
            var firstActive = arrPos[0];
            var firstItem = this.liElements[firstActive];
            firstItem.focus();
        }
    };
    BcFloatMenuBehavior.prototype.closeDropdown = function () {
        (0, helpers_1.replaceClass)(this.floatMenuContent, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS);
        (0, helpers_1.replaceClass)(this.arrowElement, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW);
        this.floatMenuActive = false;
    };
    BcFloatMenuBehavior.prototype.toggleDropdown = function (forceClose) {
        var _a;
        if (forceClose === void 0) { forceClose = false; }
        this.floatMenuActive = this.floatMenuContent
            ? (_a = this.floatMenuContent.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS)
            : false;
        if (this.floatMenuActive || forceClose) {
            this.closeDropdown();
        }
        else {
            this.openDropdown();
        }
    };
    BcFloatMenuBehavior.prototype._closeAll = function () {
        var floatMenuElements = Array.from(document.querySelectorAll("[class~='".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS, "']")));
        var floatMenuArrowElements = Array.from(document.querySelectorAll("[class~='".concat(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE, "']")));
        floatMenuElements.forEach(function (activeFloatMenu) {
            (0, helpers_1.replaceClass)(activeFloatMenu, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_CLASS);
        });
        floatMenuArrowElements.forEach(function (activeFloatMenuArrow) {
            (0, helpers_1.replaceClass)(activeFloatMenuArrow, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE, bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW);
        });
    };
    BcFloatMenuBehavior.prototype.setDropdownContentPosition = function () {
        if (this.floatMenuActive !== null) {
            this.floatMenuPosition = this.mySelf.getBoundingClientRect();
            this.floatMenuContentPosition = this.floatMenuContent.getBoundingClientRect();
            this.positionDefaultFloatMenu();
        }
    };
    BcFloatMenuBehavior.prototype.positionDefaultFloatMenu = function () {
        var _this = this;
        window.addEventListener('scroll', function () {
            var _a;
            if ((_a = _this.floatMenuContent.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS)) {
                _this.updateFloatMenuPosition();
            }
        }, true);
        window.addEventListener('resize', function () {
            var _a;
            if ((_a = _this.floatMenuContent.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS)) {
                _this.updateFloatMenuPosition();
            }
        }, true);
        this.updateFloatMenuPosition();
    };
    BcFloatMenuBehavior.prototype.updateFloatMenuPosition = function () {
        var position = this.getPosition();
        var floatMenuPos = this.getFloatMenuPosition(position);
        var floatMenuContentBox = this.floatMenuContent.getBoundingClientRect();
        this.windowWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
        this.handlePositionClasses(position, floatMenuPos, floatMenuContentBox);
        this.handleArrowClasses(position, floatMenuPos, floatMenuContentBox);
        this.handleBottomOverflowClass(position, floatMenuPos, floatMenuContentBox);
        this.setFloatMenuContentPosition(floatMenuPos);
        this._setFloatWidth(this.mySelf);
    };
    BcFloatMenuBehavior.prototype.getPosition = function () {
        var _a;
        return ((_a = this.toggleButton) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || { left: 0, top: 0 };
    };
    BcFloatMenuBehavior.prototype.getFloatMenuPosition = function (position) {
        var _a, _b;
        var floatMenuPos = { left: position.left, top: position.bottom };
        if ((_a = this.mySelf.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_RIGHT)) {
            floatMenuPos.left = position.right;
            floatMenuPos.top = position.top;
        }
        else if ((_b = this.mySelf.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_LEFT)) {
            floatMenuPos.left = position.left - this.floatMenuContent.getBoundingClientRect().width;
            floatMenuPos.top = position.top;
        }
        return floatMenuPos;
    };
    BcFloatMenuBehavior.prototype.handlePositionClasses = function (position, floatMenuPos, floatMenuContentBox) {
        var _a, _b;
        var hasPositionClass = ((_a = this.mySelf.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_RIGHT)) ||
            ((_b = this.mySelf.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_LEFT));
        if (hasPositionClass) {
            var newFloatMenuPos = this.setPositionForSideCase(position, floatMenuContentBox, floatMenuPos);
            floatMenuPos.top = newFloatMenuPos.top;
            floatMenuPos.left = newFloatMenuPos.left;
        }
    };
    BcFloatMenuBehavior.prototype.handleArrowClasses = function (position, floatMenuPos, floatMenuContentBox) {
        var _a, _b, _c;
        var hasArrowClass = ((_a = this.mySelf.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_OVERFLOW_LEFT)) ||
            ((_b = this.mySelf.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_OVERFLOW_RIGHT)) ||
            ((_c = this.mySelf.classList) === null || _c === void 0 ? void 0 : _c.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_OVERFLOW_CENTER));
        if (hasArrowClass) {
            var newFloatMenuPos = this.setPositionForArrowCase(position, floatMenuContentBox, floatMenuPos);
            floatMenuPos.top = newFloatMenuPos.top;
            floatMenuPos.left = newFloatMenuPos.left;
        }
    };
    BcFloatMenuBehavior.prototype.handleBottomOverflowClass = function (position, floatMenuPos, floatMenuContentBox) {
        var _a;
        var hasPositionBotoomClass = (_a = this.mySelf.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_POSITION_OVERFLOW_BOTTOM);
        if (hasPositionBotoomClass) {
            var newFloatMenuPos = this.setPositionForBottomOverflow(position, floatMenuContentBox, floatMenuPos, hasPositionBotoomClass);
            floatMenuPos.top = newFloatMenuPos.top;
            floatMenuPos.left = newFloatMenuPos.left;
        }
    };
    BcFloatMenuBehavior.prototype.setFloatMenuContentPosition = function (floatMenuPos) {
        this.floatMenuContent.style.left = "".concat(floatMenuPos.left, "px");
        this.floatMenuContent.style.top = "".concat(floatMenuPos.top, "px");
    };
    BcFloatMenuBehavior.prototype.setPositionForSideCase = function (toggleButtonBox, floatMenuContentBox, floatMenuFinalPos) {
        if (toggleButtonBox.right + floatMenuContentBox.width > this.windowWidth) {
            floatMenuFinalPos.left = toggleButtonBox.left - floatMenuContentBox.width;
        }
        if (toggleButtonBox.right - floatMenuContentBox.width < 0) {
            floatMenuFinalPos.left = toggleButtonBox.right;
        }
        if (toggleButtonBox.bottom + floatMenuContentBox.height > this.windowHeight) {
            floatMenuFinalPos.top = toggleButtonBox.bottom - floatMenuContentBox.height;
        }
        return floatMenuFinalPos;
    };
    BcFloatMenuBehavior.prototype.setPositionForArrowCase = function (toggleButtonBox, floatMenuContentBox, floatMenuFinalPos) {
        var _a, _b, _c, _d;
        if ((_a = this.mySelf.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_OVERFLOW_LEFT)) {
            floatMenuFinalPos.left = toggleButtonBox.right - floatMenuContentBox.width;
        }
        else if ((_b = this.mySelf.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_OVERFLOW_CENTER)) {
            floatMenuFinalPos.left =
                toggleButtonBox.right -
                    toggleButtonBox.width / common_constants_2.COMMON_CONSTANTS_NUMBERS.N2 -
                    floatMenuContentBox.width / common_constants_2.COMMON_CONSTANTS_NUMBERS.N2;
        }
        if (toggleButtonBox.left + floatMenuContentBox.width > this.windowWidth) {
            floatMenuFinalPos.left = toggleButtonBox.right - floatMenuContentBox.width;
        }
        if (toggleButtonBox.bottom + floatMenuContentBox.height > this.windowHeight) {
            floatMenuFinalPos.top =
                toggleButtonBox.top -
                    floatMenuContentBox.height -
                    bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_HEIGHT * common_constants_2.COMMON_CONSTANTS_NUMBERS.N2;
            (_c = this.arrowElement) === null || _c === void 0 ? void 0 : _c.classList.add(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE_TOP);
        }
        else {
            (_d = this.arrowElement) === null || _d === void 0 ? void 0 : _d.classList.remove(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_ACTIVE_TOP);
        }
        return floatMenuFinalPos;
    };
    BcFloatMenuBehavior.prototype.setPositionForBottomOverflow = function (toggleButtonBox, floatMenuContentBox, floatMenuFinalPos, hasBottomClass) {
        var _a, _b;
        if (hasBottomClass === void 0) { hasBottomClass = false; }
        var verticalSpace = this.arrowElement
            ? bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ARROW_HEIGHT * common_constants_2.COMMON_CONSTANTS_NUMBERS.N2
            : 0;
        if (toggleButtonBox.bottom + floatMenuContentBox.height > this.windowHeight || hasBottomClass) {
            floatMenuFinalPos.top = toggleButtonBox.top - floatMenuContentBox.height - verticalSpace;
            (_a = this.arrowElement) === null || _a === void 0 ? void 0 : _a.classList.add('bc-float-menu-arrow-active-top');
        }
        else {
            (_b = this.arrowElement) === null || _b === void 0 ? void 0 : _b.classList.remove('bc-float-menu-arrow-active-top');
        }
        return floatMenuFinalPos;
    };
    BcFloatMenuBehavior.prototype._isDisabledElement = function (elementLi) {
        var _a, _b;
        var containsDisabledElement = (_a = elementLi.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OPTION_DISABLED_CLASS);
        var containsPreloaderElement = ((_b = elementLi.classList) === null || _b === void 0 ? void 0 : _b.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS)) ||
            elementLi.querySelector('.' + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS) !== null;
        return containsDisabledElement || containsPreloaderElement;
    };
    BcFloatMenuBehavior.prototype._setAccesibility = function () {
        var ulElemnet = this.floatMenuContent.querySelector(common_constants_1.BcCommonConstants.UL_TAG);
        (0, helpers_2.addFocusable)(ulElemnet, { role: bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ROLE_MENU });
        for (var _i = 0, _a = this.liElements; _i < _a.length; _i++) {
            var iteme = _a[_i];
            var aElm = ulElemnet === null || ulElemnet === void 0 ? void 0 : ulElemnet.querySelector(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_A_TAG_ELEMENT);
            (0, helpers_2.addFocusable)(aElm, { role: bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ROLE_BUTTON });
            (0, helpers_2.addFocusable)(iteme, { tabindex: '0', role: bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_ROLE_BUTTON });
        }
        (0, helpers_2.addFocusable)(this.toggleButton, { tabindex: '0' });
    };
    BcFloatMenuBehavior.prototype._selectFirstOrLastElement = function (key) {
        var _liElements = Array.from(this.floatMenuContent.querySelectorAll(common_constants_1.BcCommonConstants.LI_TAG));
        var firstItem = _liElements[bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_NUMBER_0];
        var lastItem = _liElements[_liElements.length - bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_NUMBER_1];
        if (key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
            firstItem.focus();
        }
        else if (key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            lastItem.focus();
        }
    };
    BcFloatMenuBehavior.prototype._closeOnEsc = function (keyCode) {
        var isEsc = keyCode === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE;
        if (isEsc) {
            var toggleButtonElement = this.toggleButton;
            toggleButtonElement.focus();
            this.closeDropdown();
        }
    };
    BcFloatMenuBehavior.prototype._applySelectedBehavior = function (event, keyCode, elementLi) {
        var isElementDisabled = this._isDisabledElement(elementLi);
        var isEnterOrSpace = keyCode === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || keyCode === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER;
        var eventTarget = event.target;
        if (!isElementDisabled && isEnterOrSpace) {
            this._selectedBehavior(eventTarget);
        }
    };
    BcFloatMenuBehavior.prototype._addKeyboardEventsHandler = function () {
        var _this = this;
        var _a;
        var _loop_2 = function (elementLi) {
            var checkboxContainer = elementLi.querySelector('.' + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CHECKBOX_CLASS);
            var preloaderContainer = elementLi.querySelector('.' + bc_float_menu_constants_1.BcFloatMenuConstansts.BC_PRELOADER_CLASS);
            if (checkboxContainer !== null) {
                checkboxContainer.getElementsByTagName('input')[0].setAttribute('tabindex', '-1');
            }
            var isItemDisabled = ((_a = elementLi.classList) === null || _a === void 0 ? void 0 : _a.contains(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_OPTION_DISABLED_CLASS)) ||
                preloaderContainer !== null;
            if (isItemDisabled) {
                elementLi.setAttribute('tabindex', '-1');
            }
            elementLi.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
                _this._applySelectedBehavior(event, event['code'], elementLi);
                _this._closeOnEsc(event['code']);
                _this._selectFirstOrLastElement(event['code']);
            });
        };
        for (var _i = 0, _b = this.liElements; _i < _b.length; _i++) {
            var elementLi = _b[_i];
            _loop_2(elementLi);
        }
    };
    BcFloatMenuBehavior.prototype._itemsArrow = function () {
        var _this = this;
        var firstItem = this.liElements[0];
        var lastItem = this.liElements[this.liElements.length - bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_NUMBER_1];
        this.liElements.forEach(function (element, index) {
            element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
                if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                    if (index == _this.liElements.length - bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_NUMBER_1) {
                        firstItem.focus();
                    }
                    else {
                        element.nextElementSibling.focus();
                    }
                }
                else if (event.code === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                    if (index == bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_NUMBER_0) {
                        lastItem.focus();
                    }
                    else {
                        element.previousElementSibling.focus();
                    }
                }
            });
        });
    };
    BcFloatMenuBehavior.closeAll = function () {
        new this()._closeAll();
    };
    BcFloatMenuBehavior.removeBehaviors = function () {
        var toggleElements = document.getElementsByClassName(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_TOGGLE_CLASS);
        Array.prototype.forEach.call(toggleElements, function (el) {
            el.replaceWith(el.cloneNode(true));
        });
        var liElements = document.getElementsByClassName(bc_float_menu_constants_1.BcFloatMenuConstansts.BC_FLOAT_MENU_CLASS);
        Array.prototype.forEach.call(liElements, function (el) {
            el.replaceWith(el.cloneNode(true));
        });
    };
    BcFloatMenuBehavior.updateBehaviors = function () {
        var BEHAVIOR_REFRESH_TIMEOUT = 250;
        BcFloatMenuBehavior.closeAll();
        setTimeout(function () {
            BcFloatMenuBehavior.removeBehaviors();
            BcFloatMenuBehavior.setUpAll();
        }, BEHAVIOR_REFRESH_TIMEOUT);
    };
    return BcFloatMenuBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFloatMenuBehavior = BcFloatMenuBehavior;
